import { setTestDriveTime } from '@/context/borrower';
import { EJourneys } from '@/context/display';
import { store } from '@/context/store';

export function setInitialTestDriveTime(
    time: string | null,
    initialJourney?: EJourneys
): void {
    let testDriveDate: Date;

    if (!time) {
        // Check if we're in a test drive journey
        if (initialJourney === EJourneys.TEST_DRIVE) {
            // Set default to current time + 5 minutes
            const now = new Date();
            now.setMinutes(now.getMinutes() + 5);
            testDriveDate = now;
        } else {
            console.error('Time is null');
            return;
        }
    } else {
        // Get today's date
        const today = new Date();

        // Change today to the time of the test drive
        const timeArray = time.split(':');
        const hours = parseInt(timeArray[0], 10);
        const minutes = parseInt(timeArray[1], 10);
        testDriveDate = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            hours,
            minutes
        );
    }

    // Dispatch
    store.dispatch(setTestDriveTime(testDriveDate));
}
